// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__l40gE","carousel":"styles_carousel__Z-hT3","trusted-by":"styles_trusted-by__JXADE","trustedBy":"styles_trusted-by__JXADE","logo":"styles_logo__r6qlE"};